// @flow
export default {
  signIn: '登录',
  adminSignIn: 'ADMIN PANEL',
  username: '用户名',
  password: '密码',
  company: 'Company',
  forgotPassword: '忘记密码？',
  poweredBy: '技术支持',
  loading: 'Loading...',
  errorMessage: '用户名和（或）密码不匹配。请重试',
  errorMustNotEmpty: '用户名和（或）密码不能为空',
  inputPhoneForm: {
    inputPhoneNumber: 'INPUT PHONE NUMBER',
    instructionText: 'SMS verification will be sent to your new number.',
    inputYourPhoneNumber: 'Input your phone number',
    submit: 'SUBMIT'
  },
  inputOTPForm: {
    securityCode: 'SECURITY CODE',
    instructionText: 'We have sent an SMS with a unique code to your listed number.',
    confirm: 'CONFIRM',
    smsSentTo: 'SMS Sent to +{0}',
    didNotReceiveSMS: 'Didn\'t receive the SMS?',
    resend: 'Resend',
    error: 'Verify OTP failed, please try again!',
    sending: 'Sending...'
  }
}
